import azdararir from "../../assets/imgs/azdararir.gif";
import styles from "./ui.module.scss";

export const Azdararir = () => {
  return (
    <a
      href="https://azdararir.am/hy/"
      target="_blank"
      rel="noreferrer"
      className={styles.azdararir}
    >
      <img src={azdararir} alt="azdararir" loading="lazy" />
    </a>
  );
};
